export default "__VITE_ASSET__DIvSPUq0__"